import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { BreakableEmail } from "../UI/Table/BreakableEmail.tsx";
import { BreakableText } from "../UI/Table/BreakableText.tsx";
import { BasicTable } from "../UI/Table/BasicTable.tsx";
import { EmptyTableMessage } from "../UI/Table/EmptyTableMessage.tsx";
import { formatDateTime } from "../UI/Utils/formatDate.ts";
import { ReferralInviteePurchasedRecordDTO } from "./types.ts";

const HIDDEN_ON_MOBILE = { className: "hidden md:table-cell" };

const columnHelper = createColumnHelper<ReferralInviteePurchasedRecordDTO>();

const columns = [
  columnHelper.accessor("inviteeEmail", {
    header: "Invitee email",
    cell: (info) => <BreakableEmail email={info.getValue()} />,
  }),
  columnHelper.accessor("invitedByEmail", {
    header: "Invited by",
    meta: HIDDEN_ON_MOBILE,
    cell: (info) => <BreakableEmail email={info.getValue()} />,
  }),
  columnHelper.accessor("productName", {
    header: "Product",
    meta: HIDDEN_ON_MOBILE,
  }),
  columnHelper.accessor("orderId", {
    header: "Order ID",
    meta: HIDDEN_ON_MOBILE,
    cell: (info) => (
      <BreakableText className={"font-mono text-xs"}>
        {info.getValue()}
      </BreakableText>
    ),
  }),
  columnHelper.accessor("purchasedAt", {
    header: "Purchased",
    cell: (info) => (
      <span className={"whitespace-nowrap"}>
        {formatDateTime(info.getValue())}
      </span>
    ),
  }),
  columnHelper.accessor("refunded", {
    header: "Refunded",
    cell: (info) => (
      <span
        className={
          info.getValue()
            ? "text-red-600 font-medium"
            : "text-green-600 font-medium"
        }
      >
        {info.getValue() ? "Yes" : "No"}
      </span>
    ),
  }),
];

export function ReferredUsersTable({
  records,
}: {
  records: ReferralInviteePurchasedRecordDTO[];
}) {
  const table = useReactTable({
    columns,
    data: records,
    getCoreRowModel: getCoreRowModel(),
  });
  if (records.length === 0)
    return <EmptyTableMessage message={"No referred users found"} />;
  return (
    <BasicTable
      table={table}
      compact
      scrollableMinWidthClassName={"min-w-full"}
    />
  );
}
